
  var editorScriptEntry = require('/home/builduser/work/19aa27974f020303/packages/sm-platform-app/src/editor.app.ts');

  
    if (editorScriptEntry.default) {
      module.exports = editorScriptEntry.default;
    } else {
      const { editorScriptBuilder } = require('@wix/bob-widget-services');
      const { editorReadyWrapper, createFlowAPIFabric, exportsWrapper } = require('@wix/yoshi-flow-editor/runtime/esm/editorScript.js');

      const biLogger = require('/home/builduser/work/19aa27974f020303/packages/sm-platform-app/target/generated/bi/createBILogger.ts').createOwnerBILogger;

      

  const { initI18nWithoutICU: initI18n } = require('@wix/yoshi-flow-editor/runtime/esm/i18next/init');


      

    var createExperiments = null;
    var createWidgetExperiments = null;
    

      
const { createHttpClient } = require('@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp');
    


      const sentryConfig = {
        DSN: 'https://20259463e34b43c69e3220bfd9c13ed9@sentry.wixpress.com/573',
        id: 'f48d4c39758542a0b77a090061111251',
        projectName: 'sm-platform-app',
        teamName: 'identity',
        errorMonitor: true,
      };
      const experimentsConfig = {"scopes":["thunderbolt-viewer"],"centralized":true};
      const translationsConfig = {"icuEnabled":false,"defaultTranslationsPath":"/home/builduser/work/19aa27974f020303/packages/sm-platform-app/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
      const defaultTranslations = {"SMForm_Error_19958":"Unable to log in. Your member request is pending approval.","settings.label":"Settings","components.forgotPasswordLink.label":"Forgot password?","addElements.titles.socialComponent":"Social integration","displayNames.password":"Password","SMForm_Error_19995":"An account with this email already exists.","SMForm_Error_Email_Invalid":"Double check your email and try again.","displayNames.popup":"Custom Login Lightbox","displayNames.submit":"Submit","components.password.label":"Password","notification.title":"{{componentLabel}} is a required field. Are you sure you want to delete it?","displayNames.forgotPasswordLink":"Forgot Password Link","components.general.errorPlaceholder":"If an error occurs, a message will show here.","SMForm_Error_Password_Blank":"Make sure you enter a password.","displayNames.socialDividerLabel":"Social Divider Label","displayNames.signUpLink":"Sign Up Link","components.socialLabel.label":"&nbsp;&nbsp;or Log In with&nbsp;&nbsp;","components.subTitle.label":"New to this site?","SMForm_Error_Non_Ascii_Chars":"Use only English letters, digits and characters.","SMForm_Error_Password_Retype":"Passwords do not match. Try again.","SMForm_Error_THROTTLED":"You made too many access requests. Wait a moment before trying again.","SMForm_Error_19971":"Captcha is required to verify that you're a human.","SMForm_Error_19980":"Access denied by site owner","SMForm_Error_19999":"This email doesn't match any account. Try again.","SMForm_Error_17005":"Please enter the correct password.","SMForm_Error_Password_Length_Login":"Passwords must be at least 4 characters long. Try again.","SMForm_Error_Email_Blank":"Email cannot be blank","displayNames.title":"Title","SMForm_Error_19984":"Invalid Session","addElements.titles.email":"Email field","SMForm_Error_SESSION_BY_ID_NOT_FOUND_OR_NOT_ACTIVE":"There was a technical error on our end. Refresh the page or try again later.","SMForm_Error_19988":"Validation Error","components.email.errorPlaceholder":"If there's an email error, a message will show here.","components.signUpLink.label":"Sign Up","SMForm_Error_General_Err":"There was a technical issue. Please refresh your browser and log in again.","addElements.titles.submit":"Submit button","SMForm_Error_19956":"Unable to log in with that email. Try a different account.","displayNames.generalErrMsg":"General Error Message","components.submit.label":"Log In","addElements.titles.signUpLink":"Sign Up link","displayNames.email":"Email","SMForm_Error_17002":"This page was deleted. Reload your browser to head home.","SMForm_Error_19972":"It appears that this link has expired","addElements.titles.emailErrMsg":"Email's error message","displayNames.subTitle":"Sub Title","SMForm_Error_19976":"Wrong email or password","components.email.label":"Email","addElements.titles.forgotPasswordLink":"Forgot password link","popup.title":"Custom Login","actionLabels.addElements":"Add Elements","components.title.label":"Log In","displayNames.widget.nickname":"Custom Login","SMForm_Error_19901":"We sent you too many emails. Wait a bit before clicking resend again.","components.password.errorPlaceholder":"If there's a password error, a message will show here.","displayNames.widget":"Member Login Form","notification.caption":"click here","actionLabels.settings":"Settings","SMForm_Error_19974":"Only Velo back-end requests are permitted for this entry. Try again through Velo back-end.","addElements.titles.generalErrMsg":"General error message","addElements.titles.passwordErrMsg":"Password's error message","SMForm_Error_19970":"Verification failed. Please try again.","addElements.titles.password":"Password field","SMForm_Error_19973":"Your password has been reset. To log in, click Forgot Password above & create a new password.","SMForm_Error_Password_Length":"Password length must be between 4 and 100 characters.","actionLabels.submitSettings":"Change Text","SMForm_Error_18880":"Email address must be provided","SMForm_Error_17003":"This page isn't password protected. To view it, reload your browser.","displayNames.social":"Social Login","SMForm_Error_9990":"Access denied by site owner"};

      const createFlowAPI = createFlowAPIFabric({
        sentryConfig,
        experimentsConfig,
        translationsConfig,
        defaultTranslations,
        biLogger,
        shouldUseEssentials: true,
        artifactId: 'sm-platform-app',
        appDefId: 'bbe1406a-31f5-4f3f-9e0a-b39dfd25274f',
        optionalDeps: {
          initI18n,
          createExperiments,
          createHttpClient
        },
        localeDistPath: 'assets/locales',
      });

      const useAPIsFromExports = typeof editorScriptEntry.exports === "function";

      function wrapEditorReady(eReady) {
        try {
          return editorReadyWrapper({
            createFlowAPI,
            editorReady: eReady,
            shouldSkipAPIOverrides: useAPIsFromExports,
          });
        } catch (e) {
          console.error(e);
          throw e;
        }
      }

      let wrappedEditorReady = wrapEditorReady(editorScriptEntry.editorReady);
      if (false) {
        const hot = require('@wix/yoshi-flow-editor/build/cjs/wrappers/editorScriptHot.js').hot;
        wrappedEditorReady = hot(module, wrappedEditorReady);
      }

      let builder = editorScriptBuilder();
      if (editorScriptEntry.editorReady) {
        builder = builder.withEditorReady(wrappedEditorReady);
      }

      if (editorScriptEntry.exports) {
        builder = builder.withExports(useAPIsFromExports ? exportsWrapper(editorScriptEntry.exports) : editorScriptEntry.exports);
      }

      if (editorScriptEntry.onEvent) {
        builder = builder.withEventHandler(editorScriptEntry.onEvent);
      }
      const controllerWidgetManifests = [];
      
      const userController_0 = require('/home/builduser/work/19aa27974f020303/packages/sm-platform-app/src/components/custom Sign In/editor.controller.ts');

      const model_0 = null;

      const manifest_0 = userController_0 ? userController_0.default || userController_0 : {};
      if (!manifest_0.type) {
        manifest_0.type = "undefined";
      }
      if (!manifest_0.getExports && model_0) {
        manifest_0.getExports = () => ({"undefined": model_0.getExports()});
      }
      if (userController_0 && userController_0.getWidgetManifest) {
        controllerWidgetManifests.push({ widgetId: "undefined", getWidgetManifest: userController_0.getWidgetManifest});
      }

      builder = builder.withWidget(manifest_0);

      if (editorScriptEntry.getAppManifest || controllerWidgetManifests.length) {
        const customGetAppManifest = async (...params) => {
          const [{ appManifestBuilder }, editorSDK, contextParams] = params;
          const flowAPI = await createFlowAPI(editorSDK, contextParams);
          controllerWidgetManifests.forEach(({ widgetId, getWidgetManifest}) => {
            appManifestBuilder.configureWidget(widgetId, (builder) => getWidgetManifest(builder, editorSDK, flowAPI));
          });

          if (editorScriptEntry.getAppManifest) {
            return editorScriptEntry.getAppManifest(...params, flowAPI);
          }

          return appManifestBuilder.build();
        };
        builder = builder.withAppManifest(customGetAppManifest);
      }
      var result = builder.build();
      module.exports = result;
  }
  
